module.exports = __webpack_public_path__ + "static/media/cockroach(6).a6e552f8.PNG";